import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";

import {
	Box,
	Button,
	ButtonGroup,
	ClickAwayListener,
	Grow,
	MenuItem,
	MenuList,
	Paper,
	Popper,
} from "@material-ui/core";
import React, { useState } from "react";
import { PickupItem } from "../../../../../../model/PickupItem";
import { AssignablePickupItemStatus, statusToNextActionText, statusToText } from "../../utils";

interface IProps {
	item: PickupItem;
	status?: AssignablePickupItemStatus;
	prevStatus?: AssignablePickupItemStatus;
	nextStatus?: AssignablePickupItemStatus;
	onUpdateStatus: (item: PickupItem, nextStatus: AssignablePickupItemStatus) => Promise<void>;
}

export default function StatusButtonGroup(props: IProps) {
	const { item, status, prevStatus, nextStatus, onUpdateStatus } = props;
	const [open, setOpen] = useState(false);
	const anchorRef = React.useRef(null);

	const handleToggle = () => {
		setOpen((prevOpen) => !prevOpen);
	};

	const handleClose = (event: React.MouseEvent<EventTarget>) => {
		if (anchorRef.current && anchorRef.current.contains(event.target)) {
			return;
		}

		setOpen(false);
	};

	const handlePrevStatusClick = async () => {
		if (prevStatus) {
			await onUpdateStatus(item, prevStatus);
		}

		handleClose(null as any);
	};

	return (
		<Box>
			<ButtonGroup variant="outlined" ref={anchorRef}>
				<Button
					color="secondary"
					variant="outlined"
					onClick={async () => {
						await onUpdateStatus(item, nextStatus);
					}}
				>
					{statusToNextActionText(status)}
				</Button>
				<Button color="secondary" onClick={handleToggle}>
					<ArrowDropDownIcon />
				</Button>
			</ButtonGroup>
			<Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
				{({ TransitionProps, placement }) => (
					<Grow
						{...TransitionProps}
						style={{
							transformOrigin: placement === "bottom" ? "center top" : "center bottom",
						}}
					>
						<Paper>
							<ClickAwayListener onClickAway={handleClose}>
								<MenuList id="split-button-menu">
									<MenuItem onClick={handlePrevStatusClick}>{`Flytta till: ${statusToText(prevStatus)}`}</MenuItem>
								</MenuList>
							</ClickAwayListener>
						</Paper>
					</Grow>
				)}
			</Popper>
		</Box>
	);
}
